"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _proptypes = require("../utils/proptypes");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ButtonGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(ButtonGroup, _PureComponent);

  function ButtonGroup() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        outline = _this$props.outline,
        size = _this$props.size,
        type = _this$props.type;
    var typeSetted = type !== 'default';
    var className = (0, _classnames.default)((0, _styles.buttonClass)('group', (outline || !typeSetted) && 'outline'), this.props.className);
    return _react.default.createElement("div", {
      className: className
    }, _react.Children.toArray(children).map(function (child) {
      return (0, _react.cloneElement)(child, {
        size: size,
        outline: outline,
        type: typeSetted ? type : child.props.type
      });
    }));
  };

  return ButtonGroup;
}(_react.PureComponent);

ButtonGroup.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'size'), {
  children: _propTypes.default.any.isRequired,
  outline: _propTypes.default.bool,
  type: _propTypes.default.string
});
ButtonGroup.defaultProps = {
  outline: false,
  type: 'default'
};
var _default = ButtonGroup;
exports.default = _default;